module.exports = __webpack_public_path__ + "static/media/thirteen.92ce2658.jpeg";